import React, { memo, useEffect, useState } from 'react';
import { Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '@styles/components/button';
import { Modal } from '@components/modal';
import { translate } from '@components/i18n';
import { Select, FormItem, Option } from '@styles/components/form';
import { fetchAllAvailablePlatforms, orderTypeSelector } from '@redux/slices/order';
import { transferOrderSelector } from '@redux/slices/transfer-order/order';
import { transferRequestVerifyChangeBranch, transferTypeSelector, updateTransferPlatform } from '@redux/slices/transfer-order/select-type';

type TModalRes = {
  message: string,
  isVisible: boolean
}


export const ChangeBranchTransfer: React.FC = memo(() => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [form] = Form.useForm();
  const [modalRes, setModalRes] = useState<TModalRes>({
    isVisible: false,
    message: ''
  })
  const selectTypeState = useSelector(orderTypeSelector);
  const transferSelectTypeState = useSelector(transferTypeSelector);
  const selectOrderItemsSelector = useSelector(transferOrderSelector);
  const history = useHistory();

  const selected = transferSelectTypeState.selectedPlatform
    ? transferSelectTypeState.selectedPlatform.id
    : selectOrderItemsSelector?.order.codigoFilial

  const onSubmit = async () => {
    setIsVisible(false)

    const platformId = form.getFieldValue("platform")

    if (!platformId) {
      return
    }

    const platform = selectTypeState.allAvailablePlatforms.find(item => item.id === platformId)

    if (!platform) {
      return
    }

    if (platformId !== selected) {
      dispatch(transferRequestVerifyChangeBranch({
        data: {
          codigoFilial: parseInt(platform.id),
          pedidoId: selectOrderItemsSelector.order.id
        },
        onError: (message: string) => {
          setModalRes({ isVisible: true, message })
          form.setFieldsValue({
            platform: selected
          })
        },
        onSuccess: () => {
          dispatch(updateTransferPlatform(platform))
        }
      }))
    }
  }

  useEffect(() => {
    if (isVisible) {
      dispatch(fetchAllAvailablePlatforms());
    }
  }, [isVisible])

  return (
    <>
      <Button
        darkBlue
        height={40}
        onClick={() => {
          setIsVisible(true)
        }}>
        {translate("general.changeBranch")}
      </Button>

      <Modal
        visible={modalRes?.isVisible}
        title={translate("general.errorT")}
        onCancel={() => {
          setModalRes({ isVisible: false, message: '' })
        }}
        onOk={() => {
          setModalRes({ isVisible: false, message: '' })
          history.push("/")
        }}
        okText={translate("general.newOrder")}
      >
        {modalRes?.message}
      </Modal>

      <Modal
        title={translate('general.changeBranch')}
        destroyOnClose={true}
        className="bold-title"
        visible={isVisible}
        width="30%"
        onCancel={() => setIsVisible(false)}
        onOk={onSubmit}
      >
        <Form
          form={form}
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 24 }}
          initialValues={{
            platform: selected,
          }}
        >
          <FormItem
            label={translate('forms.labels.originPlatform')}
            name="platform"
          >
            <Select
              placeholder={translate('forms.placeholders.chooseOption')}
              loading={selectTypeState.isFetchingPlatform}
              allowClear
            >
              {selectTypeState.allAvailablePlatforms.map((t) => (
                <Option value={t.id}>
                  {t.id} - {t.description}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Form>
      </Modal>
    </>
  );
});
